import React, { Component } from "react";
import { Input, Error } from "./element";
import { formatExpirationDate } from "./utils";
const styles = {
  label: {
    fontSize: "12px",
    color: "#a89f9e",
    paddingTop: 15,
    paddingLeft: 0,
  },
};
class TillCheckout extends Component {
  constructor(props) {
    const params = new URLSearchParams(window.location.search);
    const paramAmount = params.get("amount");
    super(props);
    this.state = {
      payment: new PaymentJs(),
      publicIntegrationKey: props.publicIntegrationKey,
      transactionToken: "",
      amount: paramAmount ? paramAmount : 0,
      cardData: {},
      formData: {},
      errors: [],
      cardholderErr: "",
      cardnumberErr: "",
      monthErr: "",
      yearErr: "",
      cvvErr: "",
    };
  }

  componentDidMount() {
    this.state.payment.init(
      this.state.publicIntegrationKey,
      "numberDiv",
      "cvvDiv",
      (payment) => {
        payment.setNumberStyle({
          width: "100%",
          height: "80%",
          border: "1px solid red",
        });
        payment.setCvvStyle({
          width: "35%",
          height: "80%",
          border: "1px solid red",
        });
        payment.numberOn("input", function (data) {
          // console.log(data);
        });
        console.log(payment);
      }
    );

    //test dispatching event
  }

  handleFormChange = (e) => {
    let expiry = "";
    let month = 0;
    let year = 0;

    //vallidate

    if (e.target.name === "number") {
      e.target.value = formatCreditCardNumber(e.target.value);
    } else if (e.target.name === "expiry") {
      e.target.value = formatExpirationDate(e.target.value);
      let expiry = e.target.value.split("/");
      let month = expiry[0];
      let year = expiry[1];
    } else if (e.target.name === "cvc") {
      e.target.value = formatCVC(e.target.value);
    }

    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.value.trim(),
      },
    });

    console.log(this.state.formData);
  };

  handleTokenization = async () => {
    return await new Promise((resolve, reject) => {
      this.state.payment.tokenize(
        this.state.formData,
        (transactionToken, cardData) => {
          const cardDataValues = JSON.stringify(cardData, null, 1);
          this.setState({ cardData: cardDataValues });
          resolve(transactionToken);
          console.log("heyyy", cardData);
          //mobileapp: tokenization success
          //window.ReactNativeWebView.postMessage only accepts one argument which must be a string.
          //window.ReactNativeWebView.postMessage(transactionToken);
        },
        (errors) => {
          const errorsArr = [];
          errors.map((e) => {
            errorsArr.push(e.message);
          });
          reject(errorsArr);
          this.setState({ errors: errorsArr });
          const test = {
            success: true,
            data: errorsArr,
          };
          //mobile client tokenization error
          //window.ReactNativeWebView.postMessage only accepts one argument which must be a string.
          //window.ReactNativeWebView.postMessage("false");
        }
      );
    });
  };

  handleSubmit = (e) => {
    //mobileapp: start load

    e.preventDefault();

    //tokenization
    this.handleTokenization()
      .then((t) => {
        console.log("Tokenize Success:", t);
        this.setState({ transactionToken: t });
      })
      .catch((e) => {
        console.log("Tokenize Error:", e);
        //assign error
        this.setState({ yearErr: e[this.findString(e, "year")] });
        this.setState({ monthErr: e[this.findString(e, "month")] });
        this.setState({
          cardholderErr: e[this.findString(e, "holder")],
        });
        this.setState({
          cardnumberErr: e[this.findString(e, "number")],
        });
        this.setState({ cvvErr: e[this.findString(e, "CVV")] });
      });
  };

  findString = (arr, str) => {
    let filter = -1;
    filter = arr.findIndex((e) => {
      return e.indexOf(str) > -1;
    });
    return filter;
  };

  render() {
    return (
      <div style={{ margin: 10 }}>
        <div className="container">
          <form>
            <div className="row">
              <h2 className="text-muted" style={{ paddingLeft: 0 }}>
                Payment Method
              </h2>
            </div>
            {/* <div className="row">
              <h4 style={{ paddingLeft: 0 }}> ${this.state.amount} </h4>
            </div> */}
            <div className="row">
              <Input id="user_name" name="user_name" label="User name" />
            </div>
            {/* <div className="row">
              <Input
                id="email"
                name="email"
                onEdit={this.handleFormChange}
                label="Email"
              />
            </div> */}
            <div className="row">
              <Input
                id="card_holder"
                name="card_holder"
                onEdit={this.handleFormChange}
                label="Card holder"
              />
              <Error err={this.state.cardholderErr} />
            </div>
            <div className="row">
              <label style={styles.label}>Card number</label>
              <div
                id="numberDiv"
                style={{ padding: 0, margin: 0, height: 38 }}
              ></div>
              <Error err={this.state.cardnumberErr} />
            </div>
            <div className="row">
              {/* <div className="col" style={{ padding: 0, width: 10 }}>
                <Input
                  id="expiry"
                  name="expiry"
                  onEdit={this.handleFormChange}
                  label="Expiry"
                  pattern="\d\d/\d\d"
                  placeholder="MM/YY"
                />
                <Error err={this.state.monthErr} />
                <Error err={this.state.yearErr} />
              </div> */}
              <div className="col" style={{ padding: 0 }}>
                <Input
                  id="month"
                  name="month"
                  onEdit={this.handleFormChange}
                  label="Month"
                />
                <Error err={this.state.yearErr} />
              </div>
              <div className="col" style={{ padding: 0 }}>
                <Input
                  id="year"
                  name="year"
                  onEdit={this.handleFormChange}
                  label="Year"
                />
                <Error err={this.state.yearErr} />
              </div>
              <div className="col" style={{ padding: 0 }}>
                <label style={styles.label}>CVV</label>
                <div
                  id="cvvDiv"
                  style={{ padding: 0, margin: 0, height: 42 }}
                ></div>
                <Error err={this.state.cvvErr} />
              </div>
            </div>
            <div className="row">
              <label style={styles.label}>&nbsp;</label>
              <input
                type="submit"
                onClick={this.handleSubmit}
                // value={"Pay $" + this.state.amount}
                value={"Submit"}
                style={{
                  backgroundColor: "#FF591F",
                  border: 0,
                  color: "#fff",
                  padding: 10,
                }}
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default TillCheckout;
